<template>
  <div :class="styleMain">
    <h2>Statistiques générales</h2>
    <team-statistics-possession :match="match" :team="team" />
    <team-statistics-template v-for="stat in statistics" :key="stat.id" :match="match" :team="team" :statistic="stat" />
  </div>
</template>

<script>
import TeamStatisticsPossession from './TeamStatisticsPossession'
import TeamStatisticsTemplate from './TeamStatisticsTemplate'
import { matchStatistics } from '@/store/model/sport/football/MatchStatistics'

export default {
  name: 'SportFootballMatchTeamStatistics',
  components: { TeamStatisticsPossession, TeamStatisticsTemplate },
  props: {
    match: Object,
    team: Object
  },
  computed: {
    statistics () { return matchStatistics.list },
    styleMain () { return ['sportFootballMatchTeamStatistics', this.match?.homeAway(this.team)] }
  }
}
</script>

<style>
.sportFootballMatchTeamStatistics{
  position:relative;
  overflow:hidden;
  margin-bottom:20px;
}
.sportFootballMatchTeamStatistics > h2{
  font-size:16px;
  color:white;
  text-align: center;
}
</style>
